import React, {CSSProperties, memo} from "react";
import {Avatar, Box, Typography} from "@material-ui/core";
import ShowCard from "view/apps/Organiser/pages/Settings/EmbeddedShowList/components/ShowCard";
import {useFormStateContext} from "view/SignUp/SignUpToken/context";
import FlexBox from "view/components/Layout/FlexBox";
import FlexRow from "view/components/Layout/FlexRow";

const ShowView = memo(() => {
  const {show, activeStep} = useFormStateContext();

  if (!show) {
    return null;
  }
  const imageWidth = activeStep === 0 ? 360 : 592;

  return (
    <FlexBox column gap={0.5} alignCenter>
      <FlexRow gap={0.5}>
        <Typography>Welcome to </Typography>
        {!!show.organiserLogo && (
          <Avatar
            src={show.organiserLogo}
            variant="square"
            style={logoStyles}
          />
        )}
        <Typography style={{textAlign: "center"}}>
          {show.organiserCompany}
        </Typography>
      </FlexRow>

      <Box width={imageWidth}>
        <ShowCard show={show} viewOnly />
      </Box>
    </FlexBox>
  );
});

const logoStyles: CSSProperties = {
  maxWidth: 16,
  height: 16,
  objectFit: "cover",
};
export default ShowView;
